import React from 'react';
import ContainersIcon from 'marketing-website/components/modules/Examples/ContainersIcon';
import ContainersPreview from 'marketing-website/components/modules/Examples/ContainersPreview';
import AnchorIcon from 'marketing-website/components/modules/Examples/AnchorIcon';
import AnchorPreview from 'marketing-website/components/modules/Examples/AnchorPreview';
import EmbedIcon from 'marketing-website/components/modules/Examples/EmbedIcon';
import EmbedPreview from 'marketing-website/components/modules/Examples/EmbedPreview';
import EmbedMultimediaIcon from 'marketing-website/components/modules/Examples/EmbedMultimedia';
import EmbedMultimediaPreview from 'marketing-website/components/modules/Examples/EmbedMultimediaPreview';
import FixedHeaderFooterIcon from 'marketing-website/components/modules/Examples/FixedHeaderFooter';
import FixedHeaderFooterPreview from 'marketing-website/components/modules/Examples/FixedHeaderFooterPreview';
import LayersIcon from 'marketing-website/components/modules/Examples/Layers';
import LayersPreview from 'marketing-website/components/modules/Examples/LayersPreview';
import TimersIcon from 'marketing-website/components/modules/Examples/Timers';
import TimersPreview from 'marketing-website/components/modules/Examples/TimersPreview';
import LastVisitedIcon from 'marketing-website/components/modules/Examples/LastVisited';
import LastVisitedPreview from 'marketing-website/components/modules/Examples/LastVisitedPreview';
import TransitionsIcon from 'marketing-website/components/modules/Examples/Transitions';
import TransitionsPreview from 'marketing-website/components/modules/Examples/TransitionsPreview';
import GifIcon from 'marketing-website/components/modules/Examples/Gif';
import GifPreview from 'marketing-website/components/modules/Examples/GifPreview';

export const CONTAINERS = 'CONTAINERS';
export const LINK = 'LINK';
export const SCROLL_TO_ANCHOR = 'SCROLL_TO_ANCHOR';
export const EMBED = 'EMBED';
export const FIXED_HEADER_FOOTER = 'FIXED_HEADER_FOOTER';
export const LAYERS = 'LAYERS';
export const GIF = 'GIF';
export const TIMER = 'TIMER';
export const LAST_VISITED = 'LINK_LAST_VISITED';
export const TRANSITIONS = 'TRANSITIONS';

const features = [
  {
    id: EMBED,
    name: 'Embed',
    description: 'Add dynamic content like videos, audio and maps',
    helpId: '360003855577',
    icon: <EmbedMultimediaIcon />,
    preview: <EmbedMultimediaPreview />,
    color: '#FFD79B',
  },
  {
    id: TRANSITIONS,
    name: 'Transitions',
    description: 'Add realistic animations when transitioning to a hotspot',
    helpId: '360017013198',
    icon: <TransitionsIcon />,
    preview: <TransitionsPreview />,
    color: '#FF977A',
  },
  {
    id: CONTAINERS,
    name: 'Containers',
    description: 'Enable elements to scroll horizontally or vertically',
    helpId: '360014699118',
    preview: <ContainersPreview />,
    icon: <ContainersIcon />,
    color: '#AD6EDD',
  },
  {
    id: LINK,
    name: 'Link',
    description: 'Link to any external website, document or surveys',
    helpId: '360003842897',
    preview: <EmbedPreview />,
    icon: <EmbedIcon />,
    color: '#60D2C9',
  },
  {
    id: SCROLL_TO_ANCHOR,
    name: 'Scroll to anchor',
    description: 'Automatically scroll to another area on the same page',
    helpId: '207646029',
    icon: <AnchorIcon />,
    preview: <AnchorPreview />,
    color: '#FD6F3C',
  },
  {
    id: FIXED_HEADER_FOOTER,
    name: 'Fixed header/footer',
    description:
      'Keep the top or bottom of the design fixed while the rest of the screen scrolls',
    helpId: '209299185',
    icon: <FixedHeaderFooterIcon />,
    preview: <FixedHeaderFooterPreview />,
    color: '#2A3440',
  },
  {
    id: LAYERS,
    name: 'Layer an image',
    description:
      'Add elements on top of your screen to recreate modals, tooltips and more',
    helpId: '209299205',
    icon: <LayersIcon />,
    preview: <LayersPreview />,
    color: '#FFAE30',
  },
  {
    id: GIF,
    name: 'Gif Animation',
    description: 'Add GIFs to create animated areas in your prototype',
    helpId: '360017022798',
    icon: <GifIcon />,
    preview: <GifPreview />,
    color: '#FFC772',
  },
  {
    id: TIMER,
    name: 'Timers',
    description: 'Transition between screens after a set amount of time',
    helpId: '360002731437',
    icon: <TimersIcon />,
    preview: <TimersPreview />,
    color: '#1FB6FF',
  },
  {
    id: LAST_VISITED,
    name: 'Link to last visited screen',
    description: 'Automatically link to the previous screen the user visited',
    helpId: '360017019778',
    icon: <LastVisitedIcon />,
    preview: <LastVisitedPreview />,
    color: '#60D956',
  },
];

export default features;



// WEBPACK FOOTER //
// ./src/configs/pages/examples/features.js